module.exports = __webpack_public_path__ + "static/img/ruzhu-09.bfebf71c.png";